<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Logout',
  data () {
    return {}
  },
  async mounted () {
    try {
      await this.$store.dispatch('logout')
      this.$router.push('/login')
    } catch (error) {
      console.error(error)
    }
  }
}
</script>
